import { Components, Theme } from "@mui/material/styles";

export const MuiChip: Components<Theme>["MuiChip"] = {
  styleOverrides: {
    root: {
      borderRadius: "100px",
    },
    sizeMedium: {
      padding: "4px",
    },
    sizeSmall: {
      padding: "3px 3px 3px 4px",
    },
    colorDefault: ({ theme }) => ({
      backgroundColor: theme.palette.action.selected,
      color: theme.palette.text.primary,
      "& .MuiChip-deleteIcon": { color: theme.palette.text.primary },
      "&:hover": { backgroundColor: theme.palette.action.focus },
      "&.Mui-focusVisible": { backgroundColor: theme.palette.action.focus },
      "&.Mui-disabled": { opacity: 0.38 },
      "&:active": { backgroundColor: theme.palette.action.focus },
      "&.MuiChip-outlined": {
        backgroundColor: "transparent",
        borderColor: theme.palette.divider,
        color: theme.palette.text.primary,
        "& .MuiChip-deleteIcon": { color: theme.palette.text.primary },
        "&:hover": { backgroundColor: theme.palette.action.hover },
        "&.Mui-focusVisible": { backgroundColor: theme.palette.action.focus },
        "&.Mui-disabled": { opacity: 0.38 },
        "&:active": { backgroundColor: theme.palette.action.focus },
      },
    }),
    colorPrimary: ({ theme }) => ({
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      "& .MuiChip-deleteIcon": { color: theme.palette.primary.contrastText },
      "&:hover": { backgroundColor: theme.palette.primary.dark },
      "&.Mui-focusVisible": { backgroundColor: theme.palette.primary.dark },
      "&.Mui-disabled": { opacity: 0.38 },
      "&:active": { backgroundColor: theme.palette.primary.dark },
      "&.MuiChip-outlined": {
        backgroundColor: "transparent",
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        "& .MuiChip-deleteIcon": { color: theme.palette.primary.main },
        "&:hover": {
          backgroundColor: "var(--mui-palette-primary-_states-hover)",
          "& .MuiChip-deleteIcon": { color: theme.palette.primary.main },
        },
        "&.Mui-focusVisible": { backgroundColor: "var(--mui-palette-primary-_states-focusVisible)" },
        "&.Mui-disabled": { opacity: 0.38 },
        "&:active": { backgroundColor: "var(--mui-palette-primary-_states-focusVisible)" },
      },
    }),
    colorSecondary: ({ theme }) => ({
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
      "& .MuiChip-deleteIcon": { color: theme.palette.secondary.contrastText },
      "&:hover": { backgroundColor: theme.palette.secondary.dark },
      "&.Mui-focusVisible": { backgroundColor: theme.palette.secondary.dark },
      "&.Mui-disabled": { opacity: 0.38 },
      "&:active": { backgroundColor: theme.palette.secondary.dark },
      "&.MuiChip-outlined": {
        backgroundColor: "transparent",
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
        "& .MuiChip-deleteIcon": { color: theme.palette.secondary.main },
        "&:hover": { backgroundColor: "var(--mui-palette-secondary-_states-hover)" },
        "&.Mui-focusVisible": { backgroundColor: "var(--mui-palette-secondary-_states-focusVisible)" },
        "&.Mui-disabled": { opacity: 0.38 },
        "&:active": { backgroundColor: "var(--mui-palette-secondary-_states-focusVisible)" },
      },
    }),
    colorError: ({ theme }) => ({
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
      "& .MuiChip-deleteIcon": { color: theme.palette.error.contrastText },
      "&:hover": { backgroundColor: theme.palette.error.dark },
      "&.Mui-focusVisible": { backgroundColor: theme.palette.error.dark },
      "&.Mui-disabled": { opacity: 0.38 },
      "&:active": { backgroundColor: theme.palette.error.dark },
      "&.MuiChip-outlined": {
        backgroundColor: "transparent",
        borderColor: theme.palette.error.main,
        color: theme.palette.error.main,
        "& .MuiChip-deleteIcon": { color: theme.palette.error.main },
        "&:hover": { backgroundColor: "var(--mui-palette-error-_states-hover)" },
        "&.Mui-focusVisible": { backgroundColor: "var(--mui-palette-error-_states-focusVisible)" },
        "&.Mui-disabled": { opacity: 0.38 },
        "&:active": { backgroundColor: "var(--mui-palette-error-_states-focusVisible)" },
      },
    }),
    colorWarning: ({ theme }) => ({
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.warning.contrastText,
      "& .MuiChip-deleteIcon": { color: theme.palette.warning.contrastText },
      "&:hover": { backgroundColor: theme.palette.warning.dark },
      "&.Mui-focusVisible": { backgroundColor: theme.palette.warning.dark },
      "&.Mui-disabled": { opacity: 0.38 },
      "&:active": { backgroundColor: theme.palette.warning.dark },
      "&.MuiChip-outlined": {
        backgroundColor: "transparent",
        borderColor: theme.palette.warning.main,
        color: theme.palette.warning.main,
        "& .MuiChip-deleteIcon": { color: theme.palette.warning.main },
        "&:hover": { backgroundColor: "var(--mui-palette-warning-_states-hover)" },
        "&.Mui-focusVisible": { backgroundColor: "var(--mui-palette-warning-_states-focusVisible)" },
        "&.Mui-disabled": { opacity: 0.38 },
        "&:active": { backgroundColor: "var(--mui-palette-warning-_states-focusVisible)" },
      },
    }),
    colorInfo: ({ theme }) => ({
      backgroundColor: "#D0D9EA",
      color: "var(--mui-palette-fsw-blue)",
      "& .MuiChip-deleteIcon": { color: "var(--mui-palette-fsw-blue)" },
      "&:hover": {
        backgroundColor: "var(--mui-palette-fsw-blue-50)",
        color: theme.palette.primary.contrastText,
        "& .MuiChip-deleteIcon": { color: theme.palette.primary.contrastText },
      },
      "&.Mui-focusVisible": {
        backgroundColor: "var(--mui-palette-fsw-blue-50)",
        color: theme.palette.primary.contrastText,
        "& .MuiChip-deleteIcon": { color: theme.palette.primary.contrastText },
      },
      "&.Mui-disabled": {
        backgroundColor: "var(--mui-palette-fsw-blue-80)",
        color: theme.palette.primary.contrastText,
        "& .MuiChip-deleteIcon": { color: theme.palette.primary.contrastText },
        opacity: 0.38,
      },
      "&:active": {
        backgroundColor: "#7998D3",
        color: theme.palette.primary.contrastText,
        "& .MuiChip-deleteIcon": { color: theme.palette.primary.contrastText },
      },
      "&.MuiChip-outlined": {
        backgroundColor: "transparent",
        borderColor: theme.palette.info.main,
        color: theme.palette.info.main,
        "& .MuiChip-deleteIcon": { color: theme.palette.info.main },
        "&:hover": { backgroundColor: "var(--mui-palette-info-_states-hover)" },
        "&.Mui-focusVisible": { backgroundColor: "var(--mui-palette-fsw-blue-25)" },
        "&.Mui-disabled": { opacity: 0.38 },
        "&:active": { backgroundColor: "var(--mui-palette-fsw-blue-25)" },
      },
    }),
    colorSuccess: ({ theme }) => ({
      backgroundColor: theme.palette.success.main,
      color: theme.palette.success.contrastText,
      "& .MuiChip-deleteIcon": { color: theme.palette.success.contrastText },
      "&:hover": { backgroundColor: theme.palette.success.dark },
      "&.Mui-focusVisible": { backgroundColor: theme.palette.success.dark },
      "&.Mui-disabled": { opacity: 0.38 },
      "&:active": { backgroundColor: theme.palette.success.dark },
      "&.MuiChip-outlined": {
        backgroundColor: "transparent",
        borderColor: theme.palette.success.main,
        color: theme.palette.success.main,
        "& .MuiChip-deleteIcon": { color: theme.palette.success.main },
        "&:hover": { backgroundColor: "var(--mui-palette-success-_states-hover)" },
        "&.Mui-focusVisible": { backgroundColor: "var(--mui-palette-success-_states-focusVisible)" },
        "&.Mui-disabled": { opacity: 0.38 },
        "&:active": { backgroundColor: "var(--mui-palette-success-_states-focusVisible)" },
      },
    }),
  },
};
